import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { PopupComponent } from '@farmnet/fnx-components';
import { Subject } from 'rxjs';

@Component({
    selector: 'test-service',
    template: `
        <a class='core-index' routerLink='/core/index'>Monolith Core Index Link</a> | 
        <a class='service-page' fnwNavigate='/webapp-loader-test/page'>Service Page Link</a>
        <fnx-popup
        #popupRef
        [popupHeader]="'Allow Navigation'"
        [popupIsClosable]="true"
        (popupClosed)="close($event)"
        >
        <div fnx-popup-content>
            <fnx-popup-container>
            Should Navigate away from this component?
            </fnx-popup-container>
        </div>
        <ng-container fnx-popup-footer>
            <fnx-action-bar
            [actionBarPrimaryActionButton]="{id: 'Ok', label: 'Ok'}"
            [actionBarSecondaryActionButtons]="[{id: 'Cancel', label: 'Cancel'}]"
            (actionBarPrimaryAction)="actionBarPrimaryAction($event)"
            (actionBarSecondaryAction)="actionBarSecondaryAction($event)">
            </fnx-action-bar>
        </ng-container>
        </fnx-popup>
    `
})
export class TestServiceComponent {
    @Output() activateNavigation: EventEmitter<boolean> = new EventEmitter();

    @ViewChild(PopupComponent) popup: PopupComponent;

    opened = false;

    constructor() {}

    openDialog() {
        this.opened = true;
        this.popup.open();
    }

    close() {
        this.activateNavigation.emit(false);
        this.opened = false;
    }

    actionBarPrimaryAction() {
        this.activateNavigation.emit(true);
        this.popup.close();
        this.opened = false;
    }

    actionBarSecondaryAction() {
        this.activateNavigation.emit(false);
        this.popup.close();
        this.opened = false;
    }

}
